/**
 * JGQ — Calendrier disponibilité PDP (sync CRM temps réel)
 * API: https://app.jeugonflablequebec.ca/index.php/shopify_calendar_api/
 *
 * Flux anti double-booking:
 * 1) product_availability → jours rouges (inventaire CRM)
 * 2) check_availability au clic date + avant add-to-cart
 * 3) refresh focus / visibility / 45s
 * 4) filet panier: jgq-checkout-availability.js → validate_cart
 */
(function () {
  'use strict';

  var API_BASE = 'https://app.jeugonflablequebec.ca';
  var REFRESH_MS = 45000;
  var MSG_DATES =
    "Veuillez sélectionner la période de location (dates) avant d'ajouter au panier.";
  var MSG_UNAVAILABLE =
    "Cette plage de dates n'est plus disponible. Choisissez d'autres dates.";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function setAddEnabled(on) {
    $all(
      'button[name="add"], button.product-form__submit, .product-form__buttons button[type="submit"], .forfaits-modal__add-btn'
    ).forEach(function (btn) {
      if (on) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', 'disabled');
    });
  }

  function showDateRequired(form) {
    var pf = form && form.closest && form.closest('product-form');
    if (pf) {
      var wrap = pf.querySelector('.product-form__error-message-wrapper');
      var msg = wrap && wrap.querySelector('.product-form__error-message');
      if (wrap && msg) {
        msg.textContent = MSG_DATES;
        wrap.removeAttribute('hidden');
        try {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) {}
        return;
      }
    }
    window.alert(MSG_DATES);
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatISO(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function parseISO(str) {
    var p = String(str).split('-');
    return new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
  }

  function today0() {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  }

  function extractDaysFromText(text) {
    if (!text) return 0;
    var m = String(text).match(/(\d+)\s*(jours?|days?)/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  class JGQAvailabilityCalendar {
    constructor(containerId, productId) {
      this.container = document.getElementById(containerId);
      this.productId = String(productId);
      this.currentDate = new Date();
      this.selectedDates = [];
      this.blockedDates = [];
      this.rentalDuration = 2;
      this.productUnavailable = false;
      this.validationMessage = '';
      this.lastValidation = null;
      this.refreshInterval = null;
      this._busy = false;
      this.searchFilter = this._readSearchFilter();
      this.init();
    }

    _readSearchFilter() {
      try {
        var s = sessionStorage.getItem('jgq_availability_filter');
        if (s) return JSON.parse(s);
      } catch (e) {}
      var u = new URLSearchParams(window.location.search);
      if (u.get('availability_filter') === 'true') {
        return {
          start_date: u.get('start_date'),
          end_date: u.get('end_date'),
          duration: parseInt(u.get('duration'), 10) || 2,
        };
      }
      return null;
    }

    async init() {
      if (!this.container) return;
      this.container.innerHTML = '<div class="jgq-loading">Chargement du calendrier…</div>';
      try {
        await this.fetchAvailability();
        if (this.productUnavailable) {
          this.container.innerHTML =
            '<div class="jgq-error">Non disponible à la location (inventaire 0).</div>';
          this.dispatchDatesValidated({ available: false, reason: 'zero_inventory' });
          return;
        }
        this.render();
        this.autoSelectSearchDates();
        this.startRealtime();
      } catch (err) {
        this.container.innerHTML =
          '<div class="jgq-error">Erreur: ' + (err.message || 'indisponible') + '</div>';
        setAddEnabled(false);
      }
    }

    startRealtime() {
      this.stopRealtime();
      var self = this;
      this.refreshInterval = setInterval(function () {
        self.refreshAvailability();
      }, REFRESH_MS);
      this._onVis = function () {
        if (document.visibilityState === 'visible') self.refreshAvailability();
      };
      this._onFocus = function () {
        self.refreshAvailability();
      };
      document.addEventListener('visibilitychange', this._onVis);
      window.addEventListener('focus', this._onFocus);
    }

    stopRealtime() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
      if (this._onFocus) window.removeEventListener('focus', this._onFocus);
    }

    /** Alias legacy (forfaits.liquid) */
    stopPeriodicRefresh() {
      this.stopRealtime();
    }

    /** Plage large pour sync inventaire CRM (mois courant ±1 + filtre recherche) */
    _rangeForFetch() {
      var y = this.currentDate.getFullYear();
      var m = this.currentDate.getMonth();
      var start = new Date(y, m - 1, 1);
      var end = new Date(y, m + 2, 0);
      if (this.searchFilter && this.searchFilter.start_date && this.searchFilter.end_date) {
        var fs = parseISO(this.searchFilter.start_date);
        var fe = parseISO(this.searchFilter.end_date);
        if (fs < start) start = fs;
        if (fe > end) end = fe;
      }
      return { start: start, end: end };
    }

    async fetchAvailability() {
      var r = this._rangeForFetch();
      var url =
        API_BASE +
        '/index.php/shopify_calendar_api/product_availability/' +
        encodeURIComponent(this.productId) +
        '?start_date=' +
        formatISO(r.start) +
        '&end_date=' +
        formatISO(r.end) +
        '&_=' +
        Date.now();
      var res = await fetch(url, { cache: 'no-store' });
      var data = await res.json();
      if (!data.success) throw new Error(data.error || 'Failed to fetch availability');
      this.blockedDates = data.blocked_dates || [];
      this.productInfo = data.product;
      this.productUnavailable = !!data.product_unavailable;
    }

    dispatchDatesValidated(validation) {
      var start =
        validation.start_date ||
        (this.selectedDates.length ? this.selectedDates[0] : null);
      var end =
        validation.end_date ||
        (this.selectedDates.length
          ? this.selectedDates[this.selectedDates.length - 1]
          : null);
      this.lastValidation = {
        available: !!validation.available,
        reason: validation.reason || '',
        start_date: start,
        end_date: end,
      };
      window.dispatchEvent(
        new CustomEvent('jgqDatesValidated', {
          detail: {
            available: !!validation.available,
            reason: validation.reason || '',
            productId: this.productId,
            start_date: start,
            end_date: end,
          },
        })
      );
      setAddEnabled(!!validation.available);
    }

    async validateSelectedRange() {
      if (this.productUnavailable) {
        this.validationMessage = "Ce jeu n'est pas disponible à la location.";
        this.dispatchDatesValidated({ available: false, reason: 'zero_inventory' });
        return this.lastValidation;
      }
      if (!this.selectedDates.length) {
        this.validationMessage = 'Sélectionnez une date de début.';
        this.dispatchDatesValidated({ available: false, reason: 'incomplete_range' });
        return this.lastValidation;
      }
      var start_date = this.selectedDates[0];
      var end_date = this.selectedDates[this.selectedDates.length - 1];
      var body = new URLSearchParams({
        product_id: this.productId,
        start_date: start_date,
        end_date: end_date,
        quantity: '1',
      });
      var res = await fetch(API_BASE + '/index.php/shopify_calendar_api/check_availability', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body,
        cache: 'no-store',
      });
      var data = await res.json();
      var available = !!(data.success && data.available);
      var reason = data.reason || (available ? 'ok' : 'double_booking');
      this.validationMessage = available
        ? ''
        : reason === 'zero_inventory'
          ? "Ce jeu n'est pas disponible à la location."
          : MSG_UNAVAILABLE;
      this.dispatchDatesValidated({
        available: available,
        reason: reason,
        start_date: start_date,
        end_date: end_date,
      });
      return this.lastValidation;
    }

    render() {
      if (this.productUnavailable || !this.container) return;
      var year = this.currentDate.getFullYear();
      var month = this.currentDate.getMonth();
      var monthNames = [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ];
      var dayNames = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
      var firstDay = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var today = today0();
      var html =
        '<div class="jgq-calendar-header"><div class="jgq-calendar-title">' +
        monthNames[month] +
        ' ' +
        year +
        '</div><div class="jgq-calendar-nav">' +
        '<button type="button" data-jgq-nav="prev">←</button>' +
        '<button type="button" data-jgq-nav="next">→</button>' +
        '</div></div><div class="jgq-calendar-grid">';

      dayNames.forEach(function (d, i) {
        html +=
          '<div class="jgq-day-header" style="grid-column:' +
          (i + 1) +
          ';grid-row:1">' +
          d +
          '</div>';
      });

      var cell = 0;
      var i;
      for (i = 0; i < firstDay; i++) {
        html +=
          '<div class="jgq-day jgq-day-disabled" style="grid-column:' +
          ((cell % 7) + 1) +
          ';grid-row:' +
          (Math.floor(cell / 7) + 2) +
          '"></div>';
        cell++;
      }

      for (var day = 1; day <= daysInMonth; day++) {
        var date = new Date(year, month, day);
        var dateStr = formatISO(date);
        var isBlocked = this.blockedDates.indexOf(dateStr) !== -1;
        var compare = new Date(year, month, day);
        compare.setHours(0, 0, 0, 0);
        var isPast = compare < today;
        var isSelected = this.selectedDates.indexOf(dateStr) !== -1;
        var col = date.getDay() + 1;
        var row = Math.floor((firstDay + day - 1) / 7) + 2;
        var classes = 'jgq-day';
        var attrs = ' data-date="' + dateStr + '"';
        if (isPast) classes += ' jgq-day-disabled';
        else if (isBlocked) classes += ' jgq-day-blocked';
        else {
          classes += ' jgq-day-available';
          attrs += ' data-jgq-pick="1"';
        }
        if (isSelected) classes += ' jgq-day-selected';
        html +=
          '<div class="' +
          classes +
          '" style="grid-column:' +
          col +
          ';grid-row:' +
          row +
          '"' +
          attrs +
          '>' +
          day +
          '</div>';
        cell++;
      }

      while (cell % 7 !== 0) {
        html +=
          '<div class="jgq-day jgq-day-disabled" style="grid-column:' +
          ((cell % 7) + 1) +
          ';grid-row:' +
          (Math.floor(cell / 7) + 2) +
          '"></div>';
        cell++;
      }

      html +=
        '</div><div class="jgq-legend">' +
        '<div class="jgq-legend-item"><div class="jgq-legend-color" style="background:#d4edda"></div><span>Disponible</span></div>' +
        '<div class="jgq-legend-item"><div class="jgq-legend-color" style="background:#f8d7da"></div><span>Réservé</span></div>' +
        '<div class="jgq-legend-item"><div class="jgq-legend-color" style="background:#17a2b8"></div><span>Sélectionné</span></div>' +
        '</div>';

      if (this.selectedDates.length) {
        html +=
          '<div class="jgq-date-selection"><strong>Dates sélectionnées:</strong> ' +
          this.selectedDates
            .map(function (d) {
              return parseISO(d).toLocaleDateString('fr-CA', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              });
            })
            .join(', ');
        if (this.validationMessage) {
          html +=
            '<div class="jgq-inline-warn" style="margin-top:8px;color:#721c24;font-size:13px">' +
            this.validationMessage +
            '</div>';
        }
        html += '</div>';
      }

      this.container.innerHTML = html;
      this._bindDom();
    }

    _bindDom() {
      var self = this;
      $all('[data-jgq-nav]', this.container).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('data-jgq-nav') === 'prev') self.prevMonth();
          else self.nextMonth();
        });
      });
      $all('[data-jgq-pick]', this.container).forEach(function (el) {
        el.addEventListener('click', function () {
          self.selectDate(el.getAttribute('data-date'));
        });
      });
    }

    autoSelectSearchDates() {
      if (!this.searchFilter || !this.searchFilter.start_date) return;
      this.rentalDuration = this.searchFilter.duration || this.rentalDuration;
      this.autoSelectDays(parseISO(this.searchFilter.start_date), this.rentalDuration);
    }

    selectDate(dateStr) {
      this.syncRentalDurationFromSelection();
      var startDate = parseISO(dateStr);
      var today = today0();
      startDate.setHours(0, 0, 0, 0);
      if (startDate < today) {
        window.alert('Impossible de sélectionner une date passée.');
        return;
      }
      if (this.blockedDates.indexOf(dateStr) !== -1) {
        window.alert('Cette date est déjà réservée.');
        this.refreshAvailability();
        return;
      }
      var temp = [];
      for (var i = 0; i < this.rentalDuration; i++) {
        var n = new Date(startDate);
        n.setDate(startDate.getDate() + i);
        var ns = formatISO(n);
        n.setHours(0, 0, 0, 0);
        if (n < today || this.blockedDates.indexOf(ns) !== -1) {
          window.alert(
            'Impossible de sélectionner ' +
              this.rentalDuration +
              ' jour(s) consécutifs à partir de cette date (déjà réservé ou passé).'
          );
          this.refreshAvailability();
          return;
        }
        temp.push(ns);
      }
      this.selectedDates = temp;
      this.render();
      this.triggerEvent();
      this.validateSelectedRange().catch(function (e) {
        console.error('JGQ calendar validate', e);
      });
    }

    async refreshAvailability() {
      if (this._busy) return;
      this._busy = true;
      try {
        await this.fetchAvailability();
        if (this.productUnavailable) {
          this.container.innerHTML =
            '<div class="jgq-error">Non disponible à la location (inventaire 0).</div>';
          this.dispatchDatesValidated({ available: false, reason: 'zero_inventory' });
          return;
        }
        this.render();
        if (this.selectedDates.length) await this.validateSelectedRange();
      } catch (e) {
        console.error('JGQ refresh', e);
      } finally {
        this._busy = false;
      }
    }

    async validateSelectedDates() {
      await this.fetchAvailability();
      if (this.productUnavailable) {
        return {
          valid: false,
          message: "Ce jeu n'est pas disponible à la location.",
          reason: 'zero_inventory',
        };
      }
      this.render();
      this.syncRentalDurationFromSelection();
      if (!this.selectedDates.length) {
        this.dispatchDatesValidated({ available: false, reason: 'incomplete_range' });
        return { valid: false, message: MSG_DATES, reason: 'incomplete_range' };
      }
      if (this.rentalDuration > 0 && this.selectedDates.length !== this.rentalDuration) {
        this.dispatchDatesValidated({ available: false, reason: 'duration_mismatch' });
        return {
          valid: false,
          message:
            'Cette option nécessite ' +
            this.rentalDuration +
            ' jour(s). Re-sélectionnez une date.',
          reason: 'duration_mismatch',
        };
      }
      var today = today0();
      for (var i = 0; i < this.selectedDates.length; i++) {
        var d = parseISO(this.selectedDates[i]);
        d.setHours(0, 0, 0, 0);
        if (d < today) {
          return { valid: false, message: 'Date(s) dans le passé.', reason: 'past_date' };
        }
        if (this.blockedDates.indexOf(this.selectedDates[i]) !== -1) {
          return {
            valid: false,
            message: MSG_UNAVAILABLE,
            reason: 'blocked_date',
          };
        }
      }
      var range = await this.validateSelectedRange();
      if (!range || !range.available) {
        return {
          valid: false,
          message: this.validationMessage || MSG_UNAVAILABLE,
          reason: (range && range.reason) || 'double_booking',
        };
      }
      return { valid: true, reason: 'ok' };
    }

    setRentalDuration(days, options) {
      var next = parseInt(days, 10);
      if (!next || next < 1) return;
      var prev = this.rentalDuration;
      this.rentalDuration = next;
      var opts = options || {};
      if (prev !== next && this.selectedDates.length) {
        var startStr = this.selectedDates[0];
        if (opts.clearOnChange) {
          this.selectedDates = [];
          this.render();
          this.triggerEvent();
          return;
        }
        this.selectDate(startStr);
      }
    }

    getSelectedVariantText() {
      var form = $(
        'form[action*="/cart/add"], form[action*="/cart"], form.product-form, form[data-type="add-to-cart-form"]'
      );
      var root = form || document;
      var checked = root.querySelector(
        'input[type="radio"][name*="option"]:checked, input[type="radio"][name^="options"]:checked, fieldset input[type="radio"]:checked'
      );
      if (checked) {
        var label = root.querySelector('label[for="' + checked.id + '"]');
        var text = (label ? label.textContent : checked.value) || '';
        if (extractDaysFromText(text) > 0) return text;
      }
      var sel = root.querySelector(
        'select[name*="option"], select[name^="id"], select.product-form__input'
      );
      if (sel && sel.options && sel.selectedIndex >= 0) {
        var t = sel.options[sel.selectedIndex].text || sel.value || '';
        if (extractDaysFromText(t) > 0) return t;
      }
      return '';
    }

    syncRentalDurationFromSelection() {
      var days = extractDaysFromText(this.getSelectedVariantText());
      if (days > 0) {
        var prev = this.rentalDuration;
        this.rentalDuration = days;
        return days !== prev;
      }
      return false;
    }

    autoSelectDays(startDate, numDays) {
      this.rentalDuration = numDays;
      var today = today0();
      var temp = [];
      var cur = new Date(startDate);
      for (var i = 0; i < numDays; i++) {
        var ds = formatISO(cur);
        var check = new Date(cur);
        check.setHours(0, 0, 0, 0);
        if (check < today || this.blockedDates.indexOf(ds) !== -1) {
          this.selectedDates = [];
          this.render();
          this.triggerEvent();
          return false;
        }
        temp.push(ds);
        cur.setDate(cur.getDate() + 1);
      }
      this.selectedDates = temp;
      this.render();
      this.triggerEvent();
      this.validateSelectedRange().catch(function () {});
      return true;
    }

    async prevMonth() {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() - 1,
        1
      );
      await this.fetchAvailability();
      this.render();
    }

    async nextMonth() {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() + 1,
        1
      );
      await this.fetchAvailability();
      this.render();
    }

    triggerEvent() {
      var start = this.selectedDates[0] || null;
      var end = this.selectedDates.length
        ? this.selectedDates[this.selectedDates.length - 1]
        : null;
      window.dispatchEvent(
        new CustomEvent('jgqDatesSelected', {
          detail: {
            dates: this.selectedDates,
            productId: this.productId,
            startDate: start,
            endDate: end,
          },
        })
      );
      if (!this.selectedDates.length) {
        this.dispatchDatesValidated({ available: false, reason: 'incomplete_range' });
      }
      if (window.jgqSyncCartProperties) window.jgqSyncCartProperties();
    }

    getSelectedDates() {
      return this.selectedDates;
    }
  }

  // Fix method assignment (class field shorthand issue in older browsers)
  JGQAvailabilityCalendar.prototype.extractDaysFromText = extractDaysFromText;

  window.JGQAvailabilityCalendar = JGQAvailabilityCalendar;

  function productForms() {
    return $all(
      'form[action*="/cart/add"], form[action*="/cart"], form.product-form, form[data-type="add-to-cart-form"]'
    );
  }

  function syncCartProperties() {
    var cal = window.jgqCalendar;
    if (!cal) return;
    var dates = cal.getSelectedDates();
    var start = dates[0] || '';
    var end = dates.length ? dates[dates.length - 1] : '';
    var crmId = cal.productId || '';

    productForms().forEach(function (form) {
      function ensure(name, value) {
        var input = form.querySelector(
          'input[name="' + name + '"][data-jgq-sync="1"]'
        );
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.setAttribute('data-jgq-sync', '1');
          form.appendChild(input);
        }
        input.value = value;
      }
      if (start && end) {
        ensure('properties[Date de début]', start);
        ensure('properties[Date de fin]', end);
        ensure('properties[_jgq_item_id]', crmId);
      } else {
        $all('input[data-jgq-sync="1"]', form).forEach(function (inp) {
          inp.value = '';
        });
      }
    });
  }
  window.jgqSyncCartProperties = syncCartProperties;
  window.jgqUpdateAllForms = syncCartProperties;

  async function guardAddToCart(form) {
    var cal = window.jgqCalendar;
    if (!cal) return true;
    var dates = cal.getSelectedDates();
    if (!dates.length) {
      showDateRequired(form);
      return false;
    }
    var validation = await cal.validateSelectedDates();
    if (!validation.valid) {
      window.alert(validation.message || MSG_UNAVAILABLE);
      cal.selectedDates = [];
      cal.render();
      syncCartProperties();
      return false;
    }
    syncCartProperties();
    return true;
  }

  var submitGuardInstalled = false;

  function installSubmitGuard() {
    if (submitGuardInstalled) return;
    submitGuardInstalled = true;

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches) return;
        if (
          !form.matches(
            'form[action*="/cart/add"], form[action*="/cart"], form.product-form, form[data-type="add-to-cart-form"]'
          )
        )
          return;
        if (!window.jgqCalendar) return;
        if (form.dataset.jgqSubmitting === '1') return;

        e.preventDefault();
        e.stopPropagation();
        form.dataset.jgqSubmitting = '1';
        guardAddToCart(form)
          .then(function (ok) {
            form.dataset.jgqSubmitting = '';
            if (!ok) return;
            HTMLFormElement.prototype.submit.call(form);
          })
          .catch(function () {
            form.dataset.jgqSubmitting = '';
          });
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest(
          '.shopify-payment-button__button, button[data-testid="Checkout-button"]'
        );
        if (!btn || !window.jgqCalendar) return;
        if (btn.dataset.jgqPayOk === '1') {
          btn.dataset.jgqPayOk = '';
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var form = $(
          'form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
        );
        guardAddToCart(form).then(function (ok) {
          if (!ok) return;
          btn.dataset.jgqPayOk = '1';
          btn.click();
        });
      },
      true
    );
  }

  function getCrmId() {
    var el = $('[data-jgq-item-id]');
    if (el && el.getAttribute('data-jgq-item-id')) {
      return String(el.getAttribute('data-jgq-item-id')).trim();
    }
    return '';
  }

  function boot() {
    var holder = $('[data-jgq-item-id]');
    if (holder && holder.getAttribute('data-jgq-defer-init') === '1') {
      // Forfaits / shell: class available, instance created later
      return;
    }
    var id = getCrmId();
    var container = document.getElementById('jgq-availability-calendar');
    if (!container) return;
    if (!id) {
      console.warn('JGQ: metafield custom.crm_item_id manquant');
      if (!container.querySelector('.jgq-error')) {
        container.innerHTML =
          '<div class="jgq-error">Calendrier indisponible (CRM Item ID manquant).</div>';
      }
      setAddEnabled(false);
      return;
    }
    window.jgqCalendar = new JGQAvailabilityCalendar('jgq-availability-calendar', id);
    installSubmitGuard();
    window.addEventListener('jgqDatesSelected', syncCartProperties);
    window.addEventListener('jgqDatesValidated', function (e) {
      setAddEnabled(!!(e.detail && e.detail.available));
    });

    setTimeout(function () {
      if (!window.jgqCalendar) return;
      window.jgqCalendar.syncRentalDurationFromSelection();
      $all('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (!this.checked || !window.jgqCalendar) return;
          var label = document.querySelector('label[for="' + this.id + '"]');
          var days = extractDaysFromText(label ? label.textContent : this.value);
          if (days > 0) window.jgqCalendar.setRentalDuration(days);
        });
      });
      $all('select').forEach(function (sel) {
        sel.addEventListener('change', function () {
          if (!window.jgqCalendar) return;
          var t = this.options[this.selectedIndex]
            ? this.options[this.selectedIndex].text
            : this.value;
          var days = extractDaysFromText(t);
          if (days > 0) window.jgqCalendar.setRentalDuration(days);
        });
      });
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
